<button mat-icon-button (click)="closeClick()" class="close-button" *ngIf="showClose"><mat-icon>close</mat-icon></button>

<div *ngIf="product && showTitle" class="product-title">
  <h1> {{ getLocalizedString(product.productBlueprint.name) }} </h1>
  <h4> {{ getLocalizedString(product.productBlueprint.infoText) }} </h4>
</div>

<div *ngIf="product && showInfo" class="product-title">
  <h1> {{ getLocalizedString(product.productBlueprint.infoText) }} </h1>
</div>

<div #attributeElement  class="attribute" [class.divider]="showAttribute(attribute)" *ngFor="let attribute of attributes; let i = index">
  <ng-container *ngIf="showAttribute(attribute)">
    <h2 *ngIf="!hideAttributeHeader(attribute)"class="attribute-name"> {{ getLocalizedString(attribute.name)  }}</h2>

    <div class="attribute-numeric-wrapper" *ngIf="isNumericChange(attribute) as numericAttribute; else attributeValueChange">
      <ng-container [ngSwitch]="getNumericAttributeType(attribute)">
            <app-numeric-attribute *ngSwitchCase="NumericAttributeTypeEnum.INPUT" [product]="product"  [attribute]="numericAttribute" [currentValue]="isNumericSet(attribute)" (valueChanged)="onNumericAttributeChange(numericAttribute, $event)"></app-numeric-attribute>
            <app-numeric-attribute-select *ngSwitchCase="NumericAttributeTypeEnum.SELECT" [product]="product" [attribute]="numericAttribute" [currentValue]="isNumericSet(attribute)" (valueChanged)="onNumericAttributeChange(numericAttribute, $event)"></app-numeric-attribute-select>
      </ng-container>
    </div>

    <ng-template #attributeValueChange>
      <div class="attribute-value-wrapper">
          <app-attribute-value style="width: 25%;display: flex;justify-content: center;" *ngFor="let attributeValue of attribute.attributeValues" [isSet]="isSet(attribute, attributeValue)" [attribute]="attribute" [attributeValue]="attributeValue" [product]="product" (valueSelected)="attributeValueClick($event)"></app-attribute-value>
      </div>
    </ng-template>
  </ng-container>

  <app-attribute (attributeWasSetImmidiately)="attributeWasSetImmidiately.next($event)" [immidiatelySetAttribute]="immidiatelySetAttribute" (attributeSet)="childClick(attribute, $event)" [product]="product" [showTitle]="false" [attributes]="attributeValue.attributes" [attributeSettings]="attributeSettings?.get(attribute)?.map" *ngIf="attributeValueHasAttributes(attribute) as attributeValue "></app-attribute >
</div>
